import { useAudioMonitor } from './useAudioMonitor'

/**
 * Détecte quand l'utilisateur local parle
 * @param threshold - Seuil audio (0-1) pour considérer comme "en train de parler" (défaut: 0.3)
 * @returns Boolean indiquant si l'utilisateur parle au-dessus du seuil
 */
export function useLocalUserSpeaking(threshold = 0.3): boolean {
  const audioLevel = useAudioMonitor()
  return audioLevel >= threshold
}
